module.exports = __webpack_public_path__ + "img/Symbol_4.513d8533.png";